var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "con-upload", class: [{ disabled: _vm.isDisabled }] },
    [
      _vm.viewActive
        ? _c("view-upload-custom", { attrs: { src: _vm.viewSrc } })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "con-img-upload" },
        [
          _vm._l(
            _vm.keepRemoved ? _vm.getFilesFilter : _vm.srcs,
            function (img, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "img-upload",
                  class: {
                    fileError: img.error,
                    removeItem:
                      _vm.keepRemoved && _vm.itemRemove.includes(index),
                  },
                },
                [
                  _vm.showStar
                    ? _c(
                        "button",
                        {
                          staticClass: "btn-x-file-star",
                          class: {
                            active: img.star,
                          },
                          attrs: { type: "button", disabled: _vm.isDisabled },
                          on: {
                            click: function ($event) {
                              !_vm.isDisabled && !img.star && _vm.starFile(img)
                            },
                          },
                        },
                        [
                          _c(
                            "i",
                            {
                              staticClass: "material-icons notranslate",
                              attrs: { translate: "no" },
                            },
                            [_vm._v("star")]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn-x-file",
                      attrs: { type: "button", disabled: _vm.isDisabled },
                      on: {
                        click: function ($event) {
                          !_vm.isDisabled &&
                            (_vm.keepRemoved
                              ? _vm.removeFile(index)
                              : _vm.removeFileObject(img))
                        },
                      },
                    },
                    [
                      _c(
                        "i",
                        {
                          staticClass: "material-icons notranslate",
                          attrs: { translate: "no" },
                        },
                        [_vm._v("\n\t\t\t\t\tclear\n\t\t\t\t")]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "button-footer" }, [
                    _vm.allowMove &&
                    (_vm.keepRemoved ? _vm.getFilesFilter : _vm.srcs) &&
                    (_vm.keepRemoved
                      ? _vm.getFilesFilter.length > 1
                      : _vm.srcs.length > 1) &&
                    (_vm.keepRemoved ? img.order > 1 : index > 0)
                      ? _c(
                          "button",
                          {
                            staticClass: "btn-x-file-move move-left fa6",
                            attrs: { type: "button", disabled: _vm.isDisabled },
                            on: {
                              click: function ($event) {
                                !_vm.isDisabled && _vm.moveUp(img, index)
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-solid fa-angles-left",
                            }),
                          ]
                        )
                      : _c("span", {
                          staticClass: "btn-x-file-move move-left fa6",
                        }),
                    _vm._v(" "),
                    _c("span", { staticClass: "upload-order" }, [
                      _vm._v(_vm._s(img.order)),
                    ]),
                    _vm._v(" "),
                    _vm.allowMove &&
                    (_vm.keepRemoved ? _vm.getFilesFilter : _vm.srcs) &&
                    (_vm.keepRemoved
                      ? _vm.getFilesFilter.length > 1
                      : _vm.srcs.length > 1) &&
                    index + 1 <
                      (_vm.keepRemoved
                        ? _vm.getFilesFilter.length
                        : _vm.srcs.length)
                      ? _c(
                          "button",
                          {
                            staticClass: "btn-x-file-move move-right fa6",
                            attrs: { type: "button", disabled: _vm.isDisabled },
                            on: {
                              click: function ($event) {
                                !_vm.isDisabled && _vm.moveDown(img, index)
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-solid fa-angles-right",
                            }),
                          ]
                        )
                      : _c("span", {
                          staticClass: "btn-x-file-move move-right fa6",
                        }),
                  ]),
                  _vm._v(" "),
                  _vm.showUploadButton
                    ? _c(
                        "button",
                        {
                          staticClass: "btn-upload-file",
                          class: {
                            "on-progress": img.percent,
                            "ready-progress": img.percent >= 100,
                          },
                          style: {
                            height: `${img.percent}%`,
                          },
                          attrs: {
                            disabled: _vm.isDisabled || _vm.adicionarDisabled,
                          },
                          on: {
                            click: function ($event) {
                              !_vm.isDisabled ||
                                (_vm.adicionarDisabled && _vm.upload(index))
                            },
                          },
                        },
                        [
                          _c(
                            "i",
                            {
                              staticClass: "material-icons notranslate",
                              attrs: { translate: "no" },
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t" +
                                  _vm._s(
                                    img.percent >= 100
                                      ? img.error
                                        ? "report_problem"
                                        : "cloud_done"
                                      : "cloud_upload"
                                  ) +
                                  "\n\t\t\t\t"
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(img.percent) + " %")]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  img.src
                    ? _c("img", {
                        key: index,
                        style: {
                          maxWidth: img.orientation == "h" ? "100%" : "none",
                          maxHeight: img.orientation == "w" ? "100%" : "none",
                        },
                        attrs: { src: img.src },
                        on: {
                          touchend: function ($event) {
                            return _vm.viewImage(img.src, $event)
                          },
                          click: function ($event) {
                            !_vm.isDisabled && _vm.viewImage(img.src, $event)
                          },
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !img.src
                    ? _c(
                        "h4",
                        {
                          staticClass: "text-archive",
                          class: {
                            video:
                              _vm.previewVideo &&
                              img.fileObj &&
                              img.fileObj.type &&
                              img.type == "video",
                            audio:
                              _vm.previewVideo &&
                              img.fileObj &&
                              img.fileObj.type &&
                              img.type == "audio",
                          },
                        },
                        [
                          !_vm.previewVideo
                            ? _c(
                                "i",
                                {
                                  staticClass: "material-icons notranslate",
                                  attrs: { translate: "no" },
                                },
                                [_vm._v("\n\t\t\t\t\tdescription\n\t\t\t\t")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.previewVideo
                            ? _c("span", [
                                _vm._v(
                                  "\n\t\t\t\t\t" +
                                    _vm._s(img.name) +
                                    "\n\t\t\t\t"
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.previewVideo &&
                          img.fileObj &&
                          img.fileObj.type &&
                          img.type == "video"
                            ? _c("video", {
                                attrs: {
                                  id: "video-preview_" + index,
                                  muted: "",
                                  loop: "",
                                  playsinline: "",
                                  preload: "metadata",
                                  src: _vm.previewVideoDataSrc(img, index),
                                  type: img.fileObj.type,
                                  disabled: _vm.isDisabled,
                                },
                                domProps: { muted: true },
                                on: {
                                  loadedmetadata: function ($event) {
                                    return _vm.previewVideoLoaded(
                                      $event,
                                      index,
                                      img
                                    )
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.previewVideo &&
                          img.fileObj &&
                          img.fileObj.type &&
                          img.type == "audio"
                            ? _c("audio", {
                                attrs: {
                                  disabled: _vm.isDisabled,
                                  id: "audio-preview_" + index,
                                  muted: "",
                                  loop: "",
                                  playsinline: "",
                                  controls: "",
                                  controlslist: "noplaybackrate nodownload",
                                  preload: "metadata",
                                  src: _vm.previewVideoDataSrc(img, index),
                                  type: img.fileObj.type,
                                },
                                on: {
                                  loadedmetadata: function ($event) {
                                    return _vm.previewAudioLoaded(
                                      $event,
                                      index,
                                      img
                                    )
                                  },
                                },
                              })
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                ]
              )
            }
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "con-input-upload",
              class: {
                "on-progress-all-upload": _vm.percent != 0,
                "is-ready-all-upload": _vm.percent >= 100,
                "disabled-upload":
                  _vm.isDisabled ||
                  _vm.adicionarDisabled ||
                  _vm.$attrs.hasOwnProperty("disabled") ||
                  _vm.limit
                    ? _vm.srcs.length -
                        (_vm.keepRemoved ? _vm.itemRemove.length : 0) >=
                      Number(_vm.limit)
                    : false,
              },
            },
            [
              _c(
                "input",
                _vm._b(
                  {
                    ref: "fileInput",
                    attrs: {
                      disabled:
                        _vm.isDisabled ||
                        _vm.adicionarDisabled ||
                        _vm.$attrs.disabled
                          ? true
                          : _vm.limit
                          ? _vm.srcs.length -
                              (_vm.keepRemoved ? _vm.itemRemove.length : 0) >=
                            Number(_vm.limit)
                          : false,
                      type: "file",
                    },
                    on: { change: _vm.getFiles },
                  },
                  "input",
                  _vm.$attrs,
                  false
                )
              ),
              _vm._v(" "),
              _c("span", { staticClass: "text-input" }, [
                _vm._v("\n\t\t\t\t" + _vm._s(_vm.text) + "\n\t\t\t"),
              ]),
              _vm._v(" "),
              _c("span", {
                staticClass: "input-progress",
                style: {
                  width: `${_vm.percent}%`,
                },
              }),
              _vm._v(" "),
              _vm.showUploadButton
                ? _c(
                    "button",
                    {
                      staticClass: "btn-upload-all vs-upload--button-upload",
                      attrs: {
                        disabled:
                          _vm.filesx.length == 0 ||
                          _vm.isDisabled ||
                          _vm.adicionarDisabled,
                        type: "button",
                        title: "Upload1",
                      },
                      on: {
                        click: function ($event) {
                          !_vm.isDisabled ||
                            (_vm.adicionarDisabled && _vm.upload("all"))
                        },
                      },
                    },
                    [
                      _c(
                        "i",
                        {
                          staticClass: "material-icons notranslate",
                          attrs: { translate: "no" },
                        },
                        [_vm._v("\n\t\t\t\t\tcloud_upload\n\t\t\t\t")]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.showUploadButton
                ? _c(
                    "button",
                    {
                      staticClass: "btn-upload-all vs-upload--button-upload",
                      attrs: {
                        type: "button",
                        title: "Upload2",
                        disabled: _vm.isDisabled || _vm.adicionarDisabled,
                      },
                      on: {
                        click: function ($event) {
                          !_vm.isDisabled ||
                            (_vm.adicionarDisabled &&
                              _vm.$refs.fileInput.click($event))
                        },
                      },
                    },
                    [
                      _vm.textUpload
                        ? _c("span", { staticClass: "text-input" }, [
                            _vm._v(
                              "\n\t\t\t\t\t" +
                                _vm._s(_vm.textUpload) +
                                "\n\t\t\t\t"
                            ),
                          ])
                        : _c(
                            "i",
                            {
                              staticClass: "material-icons notranslate",
                              attrs: { translate: "no" },
                            },
                            [_vm._v("\n\t\t\t\t\tcloud_upload\n\t\t\t\t")]
                          ),
                    ]
                  )
                : _vm._e(),
            ]
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }